import moment from 'moment'
import { cns, cpf, ErrorObject, required } from 'util/validation'

import AtestadoModel from './components/model-atestado'

const LIMITE_90_DIAS_ANTERIORES_ATENDIMENTO_ERROR = 'Limite de 90 dias anteriores à data do atendimento.'
const DATA_DEVE_SER_ANTERIOR_OU_IGUAL_ATENDIMENTO_ERROR = 'Deve ser anterior ou igual à data do atendimento.'
const CPF_CNS_INVALIDO_ERROR = 'CPF/CNS inválido.'

export const validateDataAtestado = (
  values: AtestadoModel,
  errors: ErrorObject<AtestadoModel>,
  dataAtendimento: number | LocalDate | undefined
) => {
  if (errors.data) return

  const dataAtestado = moment(values.data)
  const dataAtendimentoMoment = moment(dataAtendimento)
  const dataLimiteInferior = moment(dataAtendimento).subtract(90, 'd').format('YYYY-MM-DD')

  if (dataAtestado.isBefore(dataLimiteInferior)) {
    errors.data = LIMITE_90_DIAS_ANTERIORES_ATENDIMENTO_ERROR
  } else if (dataAtestado.isAfter(dataAtendimentoMoment)) {
    errors.data = DATA_DEVE_SER_ANTERIOR_OU_IGUAL_ATENDIMENTO_ERROR
  }
}

export const validateCpfCnsAtestado = (
  values: AtestadoModel,
  errors: ErrorObject<AtestadoModel>,
  possuiCpfCns: boolean
) => {
  if (errors.cpfCns || values.naoPossui || possuiCpfCns) return

  errors.cpfCns = required(values.cpfCns)

  if (!values.cpfCns) return

  const [lengthCpf, cpfRule] = cpf
  const [lengthCns, cnsRule] = cns

  if (lengthCpf && cpfRule(values.cpfCns) && lengthCns && cnsRule(values.cpfCns)) {
    errors.cpfCns = CPF_CNS_INVALIDO_ERROR
  }
}
